import React from "react";
import DrPrimeInfoCard from "./components/DrPrimeInfoCard";

function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #ecf8ff6c 0%, #cff0ff6e 100%), url('/Wave-Bg2.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <DrPrimeInfoCard />
    </div>
  );
}

export default App;